export class DiceLayout {
    constructor() {
        this.container = document.createElement('div');
        this.container.style.position = 'fixed';
        this.container.style.top = '20px';
        this.container.style.right = '20px';
        this.container.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
        this.container.style.padding = '10px';
        this.container.style.borderRadius = '10px';
        this.container.style.display = 'none';
        this.container.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';

        this.canvas = document.createElement('canvas');
        this.canvas.width = 150;
        this.canvas.height = 200;
        this.container.appendChild(this.canvas);
        document.body.appendChild(this.container);

        this.ctx = this.canvas.getContext('2d');
        this.drawDiceLayout();
    }

    show() {
        this.container.style.display = 'block';
    }

    hide() {
        this.container.style.display = 'none';
    }

    drawDiceLayout() {
        const ctx = this.ctx;
        const cellSize = 30;  // 减小单元格大小使布局更紧凑
        const padding = 2;    // 减小间距

        // 清空画布
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        // 设置标题
        ctx.fillStyle = '#333'
        ctx.font = 'bold 14px Arial';
        ctx.fillText('骰子展开图', 35, 20);

        // 定义骰子面的位置（十字形布局）
        const faces = [
            { x: cellSize + padding, y: cellSize + padding + 30, value: 1 },      // 中间（前）
            { x: 2 * cellSize + 2 * padding, y: cellSize + padding + 30, value: 4 }, // 右
            { x: cellSize + padding, y: 2 * cellSize + 2 * padding + 30, value: 5 }, // 下
            { x: cellSize + padding, y: 0 + padding + 30, value: 2 },               // 上
            { x: 0 + padding, y: cellSize + padding + 30, value: 3 },               // 左
            { x: 3 * cellSize + 3 * padding, y: cellSize + padding + 30, value: 6 }  // 右（后）
        ];

        // 绘制每个面
        faces.forEach(face => {
            // 根据点数设置不同的背景颜色
            const colors = {
                1: '#FFFFFF',  // 白色
                2: '#4169E1',  // 蓝色
                3: '#9370DB',  // 紫色
                4: '#FFA500',  // 橙色
                5: '#3CB371',  // 绿色
                6: '#DC143C'   // 红色
            };
            
            // 绘制骰子面背景
            ctx.fillStyle = colors[face.value];
            ctx.fillRect(face.x, face.y, cellSize, cellSize);
            
            // 绘制边框
            ctx.strokeStyle = '#333';
            ctx.lineWidth = 1;
            ctx.strokeRect(face.x, face.y, cellSize, cellSize);

            // 绘制点数
            this.drawDots(ctx, face.x, face.y, cellSize, face.value);
        });
    }

    drawDots(ctx, x, y, size, value) {
        const dotRadius = 4;
        ctx.fillStyle = '#333'
        const positions = {
            1: [[0, 0]],
            2: [[-0.25, -0.25], [0.25, 0.25]],
            3: [[-0.25, -0.25], [0, 0], [0.25, 0.25]],
            4: [[-0.25, -0.25], [-0.25, 0.25], [0.25, -0.25], [0.25, 0.25]],
            5: [[-0.25, -0.25], [-0.25, 0.25], [0, 0], [0.25, -0.25], [0.25, 0.25]],
            6: [[-0.25, -0.25], [-0.25, 0], [-0.25, 0.25], [0.25, -0.25], [0.25, 0], [0.25, 0.25]]
        };

        ctx.fillStyle = value === 1 ? '#FF0000' : '#FFFFFF';  // 1点使用红色点，其他使用白色点
        const dots = positions[value];
        dots.forEach(([dx, dy]) => {
            const centerX = x + size * (0.5 + dx);
            const centerY = y + size * (0.5 + dy);
            ctx.beginPath();
            ctx.arc(centerX, centerY, dotRadius, 0, Math.PI * 2);
            ctx.fill();
        });
    }
}